import { PropertyOption } from "../types/chatWindow.types";

export const getTimeAgo = (dateString: string): string => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    if (diffInSeconds < 60) return "just now";
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `${diffInHours}h ago`;
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays === 1) return "yesterday";
    if (diffInDays < 7) return `${diffInDays}d ago`;

    return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

export const escapeRegex = (s: string): string => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const buildMentionRegex = (properties: PropertyOption[]): RegExp => {
    const tokens = properties
        .filter((p) => p.code !== "all")
        .flatMap((p) => [escapeRegex(p.code), escapeRegex(p.name)])
        .sort((a, b) => b.length - a.length);

    if (tokens.length === 0) return /$^/; // Matches nothing if empty

    return new RegExp(`\\B@(${tokens.join("|")})(?=\\s|$)`, "gi");
};

export const parseMentions = (input: string, properties: PropertyOption[]): PropertyOption[] => {
    if (/\B@all(?=\s|$)/i.test(input)) {
        return [{ code: "all", name: "all" }];
    }

    const regex = buildMentionRegex(properties);
    const results: PropertyOption[] = [];

    const map = new Map<string, PropertyOption>();
    for (const p of properties) {
        map.set(p.code.toLowerCase(), p);
        map.set(p.name.toLowerCase(), p);
    }

    let match: RegExpExecArray | null;
    while ((match = regex.exec(input)) !== null) {
        const token = match[1].toLowerCase();
        const prop = map.get(token);
        if (prop && !results.includes(prop)) {
            results.push(prop);
        }
    }

    return results;
};